// uses a Linear Congruential Geneator to generate a psuedo random sequence

// https://en.wikipedia.org/wiki/Linear_congruential_generator
export function LCG(seed: number) {
  if (seed == null) {
    seed = Math.random();
  }
  return () => {
    seed = Math.imul(1597334677, seed) | 0 % 2147483647;
    return (seed & 2147483647) / 2147483648;
  };
}

export function createShuffle(nextRandom: () => number) {
  return function shuffle<T>(array: Array<T>) {
    const length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    const result = [...array];
    // This is using the Fisher-Yates shuffle. Ref https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle

    for (let index = array.length - 1; index > 0; index -= 1) {
      const random = nextRandom();
      const rand = Math.floor(random * (index + 1));
      const value = result[rand];
      result[rand] = result[index];
      result[index] = value;
    }
    return result;
  };
}

function defaultRandomNumber({
  seed,
  extraRandom = 1,
}: {
  seed: number;
  extraRandom?: number;
}) {
  if (seed == null) {
    seed = Math.random();
  }
  return LCG(seed * extraRandom);
}

export function shuffler({
  seed,
  extraRandom,
}: { seed?: number; extraRandom?: number } = {}) {
  if (seed == null) {
    seed = Math.random();
  }
  return createShuffle(defaultRandomNumber({ seed, extraRandom }));
}
